export default "__VITE_ASSET__32Mu7ggQ__"